import { FiUsers } from "react-icons/fi";

const SIZE = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-10 w-10",
  xl: "h-14 w-14",
};
const ICON = {
  sm: "h-3 w-3",
  md: "h-4 w-4",
  lg: "h-5 w-5",
  xl: "h-6 w-6",
};

/** A group chat's picture: the same round shape as a person's, with a group mark. */
const GroupAvatar = ({ size = "md", isDark = true, className = "" }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center rounded-full ring-1 ${SIZE[size] || SIZE.md} ${
      "bg-fill-secondary text-label-secondary ring-separator-default"
    } ${className}`}
    aria-hidden
  >
    <FiUsers className={ICON[size] || ICON.md} />
  </span>
);

export default GroupAvatar;
